/**
 * PATH: packages/ui/src/components/settings/AllKanbanSettingsTabSlot.tsx
 * FILE_ID: UI-SETTINGS-ALL-KANBAN-SLOT-001
 * PURPOSE: Preferences All Kanban slot that does not import settings-home.
 * ROLE IN ARCHITECTURE: Gear Settings tab body until the host registers the real tab.
 * MAIN EXPORTS: AllKanbanSettingsTabSlot
 * NON-RESPONSIBILITIES: Does not persist prefs or mount This-board pages.
 * NOTES FOR FUTURE AI: Keep this file free of settings-home and @quotech/api.
 */

import { getSettingsHubConfig } from '@quotech/tenant-shared/settings/settingsHubConfig'

import {
  getAllKanbanSettingsTab,
  type AllKanbanSettingsTabProps,
} from './allKanbanSettingsTabRegistry'

export function AllKanbanSettingsTabSlot(props: AllKanbanSettingsTabProps) {
  const config = getSettingsHubConfig()
  const Tab = getAllKanbanSettingsTab()

  if (!config.showAllKanbanTab || !Tab) {
    return (
      <p data-testid="settings-all-kanban-unavailable" className="text-sm text-neutral-500">
        All Kanban settings are not enabled for this host.
      </p>
    )
  }

  return <Tab {...props} />
}
